import { Box, InputBase, styled } from '@mui/material';

export const AccessTokenInputWrapper = styled(Box)({
  p: '2px 4px',
  display: 'flex',
  alignItems: 'center',
  width: '460px',
  height: '34px',
  border: 'solid 1px rgb(217, 217, 217)',
  marginTop: '10px',
  borderRadius: '8px'
});

export const AccessTokenInput = styled(InputBase)({
  color: 'black',
  fontSize: '13px',
  margin: '0 10px',
  width: '100%'
});

export const ClaimList = styled('ul')({
  padding: 0,
  margin: '10px 0 0 10px',
  listStyle: 'none',
  fontSize: '13px'
});

export const ClaimListItem = styled('li')({
  '& > strong': {
    display: 'inline-block',
    minWidth: '120px',
    marginRight: '6px'
  }
});
